import http from "../http/http-config";
import { WorkOccasionQuotationResponse } from "../models/WorkOccasionQuotationResponse";

export default new class getNewIntegralMaxQuotation {
    createNewIntegralMaxQuotation(model: Record<string, unknown>): Promise<WorkOccasionQuotationResponse> {
        return http.post<WorkOccasionQuotationResponse>(
            "NewIntegralMaxQuotation/GetIntegralMaxQuotation",
            model,
            { headers: { "Content-Type": "application/json" } }
        ).then(response => response.data);
    }
}
